<div class="end-gap" aria-hidden="true"></div>
<div class="floating-buttons">
    <ng-content></ng-content>
</div>
